import { createApi } from '@reduxjs/toolkit/query/react';
import { setUserPermissions } from "store/slices/authSlice";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/account",
  }),
  endpoints: (builder) => ({
    verifyActivationToken: builder.query({
      query: (token) => ({
        url: `/verification/${token}`
      }),
      transformResponse: (response) => {
        return response?.data;
      }
    }),
    activateAccount: builder.mutation({
      query: ({ payload, token }) => ({
        url: `/verify/email/${token}`,
        method: 'POST',
        data: payload,
      })
    }),
    getPermissions: builder.query({
      query: () => ({
        url: `/permissions`,
      }),
      transformResponse: (response) => {
        return response?.data;
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          console.log("data", data)
          dispatch(setUserPermissions(data));
        } catch (error) {
          console.error('Login failed:', error);
        }
      },
    }),
  }),
});

export const {
  useActivateAccountMutation,
  useVerifyActivationTokenQuery,
  useGetPermissionsQuery,
} = accountApi;